import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  playerName: "",
  playerRole: "",
  quizCode: "",
  currentQuiz: null,
  currentQuestionIndex: 0,
  answers: [],
  score: 0,
  isQuizActive: false,
};

const quizSlice = createSlice({
  name: "quiz",
  initialState,
  reducers: {
    setPlayerInfo: (state, action) => {
      state.playerName = action.payload.name;
      state.playerRole = action.payload.role;
    },
    setQuizCode: (state, action) => {
      state.quizCode = action.payload;
    },
    setCurrentQuiz: (state, action) => {
      state.currentQuiz = action.payload;
      state.currentQuestionIndex = 0;
      state.answers = [];
      state.score = 0;
      state.isQuizActive = true;
    },
    nextQuestion: (state) => {
      state.currentQuestionIndex += 1;
    },
    addAnswer: (state, action) => {
      state.answers.push(action.payload);
      if (action.payload.isCorrect) {
        state.score += action.payload.points || 1;
      }
    },
    endQuiz: (state) => {
      state.isQuizActive = false;
    },
    resetQuiz: () => initialState,
  },
});

export const {
  setPlayerInfo,
  setQuizCode,
  setCurrentQuiz,
  nextQuestion,
  addAnswer,
  endQuiz,
  resetQuiz,
} = quizSlice.actions;

export default quizSlice.reducer;
